export class ValidationUtils {
  // Allow only alphabetic characters and spaces for names, and limit to 16 characters
  static validateNameInput(value: string): string {
    return value.replace(/[^a-zA-Z\s]/g, '').slice(0, 25); // Remove numbers and special characters, limit to 16 characters
  }

  // Allow all characters and limit to 9 characters
  static validateCodeInput(value: string): string {
    return value.slice(0, 9); // Allow all characters, limit to 9 characters
  }
}
